/**
 * @generated SignedSource<<0b5c1dfd39e14da02d2ca716e75d7cb5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedDetailShipping_item$data = {
  readonly attributes: {
    readonly leadTime: ReadonlyArray<{
      readonly option: {
        readonly urlLabel: string | null;
      } | null;
    } | null> | null;
  } | null;
  readonly isMultiSku: boolean;
  readonly isSold: boolean | null;
  readonly isUnpurchasable: boolean | null;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedDetailShipsFrom_item" | "PdpSharedShippingInfoWrapper_item">;
  readonly " $fragmentType": "PdpSharedDetailShipping_item";
};
export type PdpSharedDetailShipping_item$key = {
  readonly " $data"?: PdpSharedDetailShipping_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedDetailShipping_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedDetailShipping_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedShippingInfoWrapper_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedDetailShipsFrom_item"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isSold",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isUnpurchasable",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isMultiSku",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ItemAttributes",
      "kind": "LinkedField",
      "name": "attributes",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "AttributeValue",
          "kind": "LinkedField",
          "name": "leadTime",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "AttributeOption",
              "kind": "LinkedField",
              "name": "option",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "urlLabel",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "71cc5552437d4c6252aee7d61ee9bd7f";

export default node;
